import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  Legend
} from 'recharts';
import { ChartContainer, CustomTooltip } from './ChartContainer';

export const TrafficChart = ({ data, timeRange }) => {
  // Format date labels based on time range
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (timeRange === 'today') {
      return date.toLocaleTimeString('en-US', { hour: '2-digit' });
    }
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <ChartContainer 
      title="Traffic Overview" 
      subtitle="Visitors and page views over time"
      className="col-span-2"
    >
      <div className="h-[320px] w-full" data-testid="traffic-chart">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorVisitors" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(42, 48%, 56%)" stopOpacity={0.4}/>
                <stop offset="95%" stopColor="hsl(42, 48%, 56%)" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorPageViews" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(140, 25%, 65%)" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="hsl(140, 25%, 65%)" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid 
              strokeDasharray="3 3" 
              stroke="hsl(140, 5%, 15%)" 
              strokeOpacity={0.5}
              vertical={false}
            />
            <XAxis 
              dataKey="date" 
              tickFormatter={formatDate}
              stroke="hsl(100, 5%, 60%)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
              dy={10}
            />
            <YAxis 
              stroke="hsl(100, 5%, 60%)"
              fontSize={11}
              tickLine={false}
              axisLine={false}
              dx={-10}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{
                paddingTop: '20px',
                fontSize: '12px',
                fontFamily: 'Manrope, sans-serif'
              }}
            />
            <Area
              type="monotone"
              dataKey="pageViews"
              name="Page Views"
              stroke="hsl(140, 25%, 65%)"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorPageViews)"
            />
            <Area
              type="monotone"
              dataKey="visitors"
              name="Visitors"
              stroke="hsl(42, 48%, 56%)"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorVisitors)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </ChartContainer>
  );
};
